<template>
    <div class="custom-scroll h-100">

        <div class="loader_calendar w-100 text-center pt-5 mt-5" v-if="!is_load">
            <sync-loader :loading="true" color="#7a59ad"  size="10px"></sync-loader>
        </div>

        <ul class="notification" v-else>

            <li class="unread" v-for="chat in this.data">
                <a :href=chat.url class="d-flex align-items-center">
                    <span class="status mr-2">
                        <span class="profile-image rounded-circle d-inline-block"
                              v-bind:style="{
                                      'background-image': 'url(' + chat.user.medium_img + ')',
                                      'background-size': 'cover'
                                      }">
                        </span>
                    </span>
                    <span class="d-flex flex-column flex-1 ml-1">
                        <span class="name"> {{chat.user_name}}
                            <span class="badge badge-primary fw-n position-absolute pos-top pos-right mt-1">
                                {{chat.number}}
                            </span>
                        </span>
                        <span class="msg-a fs-sm">Повідомлення</span>
                        <span class="msg-b fs-xs">{{chat.message}}</span>
                        <span class="fs-nano text-muted mt-1">
                            {{chat.added}}
                        </span>
                    </span>
                </a>
            </li>

        </ul>
    </div>
</template>

<script>
    import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

    export default {
        name: "message",

        components : {
            SyncLoader,
        },

        created() {
            this.load_messages();
        },

        data() {
            return {
                is_load:false,
                message_url : "/index.php?option=com_imc_docs&task=dashboard.getMessages",
                data : [],
            }
        },

        methods : {
            async load_messages() {
                await portal_api.post(this.message_url,qs.stringify({
                    "filter": "cur_month"

                })).then(({data}) => {
                    this.is_load = true;
                    if (data.status === "operation_success") {
                        this.data = data.message;
                    } else {
                        this.data =[];
                    }
                }).catch(err => {
                    this.data = [];
                    this.is_load = false;
                });
            },

        }

    }
</script>

<style scoped>

</style>
